import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useGetInvestmentFundsQuery } from 'api/main';
import { userSelectors } from 'reducers';
import { conventionStatus } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import SubscriptionsFlux from './SubscriptionsFlux';
import SubscriptionsValueData from './SubscriptionsValueData';
import AdmissionFeeData from './AdmissionFeeData';
import ManagementFeeData from './ManagementFeeData';
import { ListContainer, Loader } from 'components';
import { Box, Typography, Grid } from '@mui/material';

const DistributorRemunerations = () => {
    const currentSubscription = useSelector(userSelectors.getCurrentSubscription);
    const { data: fundList = [], isFetching: fundsLoader } = useGetInvestmentFundsQuery();

    const filteredProducts = useMemo(
        () =>
            fundList.filter(
                p =>
                    p.visible &&
                    currentSubscription?.distributorCompany?.conventions.find(
                        c =>
                            +c.investmentFund?.id === p.id &&
                            c.status === conventionStatus.FULLY_SIGNED
                    )
            ),
        [fundList, currentSubscription]
    );

    return (
        <ListContainer>
            <Box>
                <Typography variant="h5" align="left" gutterBottom>
                    {texts.REMUNERATIONS}
                </Typography>
            </Box>
            <Loader loading={fundsLoader}>
                <Grid container spacing={2}>
                    <Grid item sm={6} xs={12}>
                        <SubscriptionsFlux products={filteredProducts} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <SubscriptionsValueData products={filteredProducts} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <AdmissionFeeData products={filteredProducts} />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <ManagementFeeData products={filteredProducts} />
                    </Grid>
                </Grid>
            </Loader>
        </ListContainer>
    );
};

export default DistributorRemunerations;
